import { render, staticRenderFns } from "./HistoryList.vue?vue&type=template&id=854a205a&scoped=true"
import script from "./HistoryList.vue?vue&type=script&lang=js"
export * from "./HistoryList.vue?vue&type=script&lang=js"
import style0 from "./HistoryList.vue?vue&type=style&index=0&id=854a205a&prod&lang=css"
import style1 from "./HistoryList.vue?vue&type=style&index=1&id=854a205a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "854a205a",
  null
  
)

export default component.exports